import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {ProviderEvent, ProviderEventListFilterValue, ProviderEventSortBy} from "./domain";
import {SortOrder} from "../client/domain";
import {subDays} from "date-fns";
import {DEFAULT_PAGE_SIZE} from "../const";

export type ProviderEventListAction =
    | { type: 'SET_SELECTED'; selected: ProviderEvent | null }
    | { type: 'SET_SORT_BY'; sortBy: ProviderEventSortBy }
    | { type: 'SET_SEARCH'; search: string }
    | { type: 'SET_REFETCH_FUNC'; refetchFunc: () => void }
    | { type: 'SET_FILTER'; filter: ProviderEventListFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload;


export interface ProviderEventListState {
    selected: ProviderEvent | null;
    refetchFunc: (() => void ) | null;
    pagination: RelayPaginationState;
    sortBy: ProviderEventSortBy;
    filter: ProviderEventListFilterValue;
    pageSize: number;
}


export function initState(): ProviderEventListState {
    const defaultPagination = new RelayPaginationState('0', DEFAULT_PAGE_SIZE);
    return {
        refetchFunc: null,
        selected: null,
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        filter: {
            eventSince: subDays(new Date(), 30),
            eventTypes: "",
            viewedOnly: "",
            reportSubmittedBy: [],
            clients: []
        },
        sortBy: {
            column: "eventTime",
            order: SortOrder.DESC,
        },
    };
}

export function providerEventListReducer(
    state: ProviderEventListState,
    action: ProviderEventListAction
): ProviderEventListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            };
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy,
                pagination: new RelayPaginationState('0', state.pageSize),
            };
        case "SET_REFETCH_FUNC":
            return {
                ...state,
                refetchFunc: action.refetchFunc,
            }
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            }
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };
        default:
            return state;
    }
}
